class SWCacheService {

    registerServiceWorker(path) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .register(path)
                .then(registration => {
                    console.log('ServiceWorker registered with scope:', registration.scope);
                })
                .catch(error => {
                    console.error('ServiceWorker registration failed:', error);
                });
        }
    }

    resetCache(include, exclude) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker?.controller?.postMessage({ type: 'RESET_CACHE', include, exclude });
        }
    }

    invalidateCacheEntries(urls) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker?.controller?.postMessage({ type: 'DELETE_CACHE_ENTRY', urls });
        }
    }

    getCacheHeader(policy, type, options = []) {
        return {
            'X-HARRI-CACHE': [policy, type, ...options].join(';')
        }
    }
}

export const swCacheService = new SWCacheService();